import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useAppDispatch } from '../../hooks/redux';
import { getProductBySlug } from '../../api/apis';
import { IProduct } from '../../lib/interfaces/Product';
import paths from '../../lib/consts/paths';
import ContentRenderer from '../Smart/Content/ContentRenderer';
import PageLoader from '../Simple/Loader/PageLoader';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import { setLoginModalOpen } from '../../redux/reducers/ui/modalsReducer';
import {
	CONTENT_FIELDS,
	getContentFieldValue,
} from '../../lib/helpers/content.helper';
import './ProductDetails.scss';
import CtaButton from '../Simple/CtaButtons/CtaButton';

const ProductDetails: FC = () => {
	const { slug = '' } = useParams();

	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const { data: productData } = useQuery<IProduct, Error>(
		['product', slug],
		() => getProductBySlug(slug),
	);
	const { data: currentUser } = useUserMeQuery();

	const handleOrder = () => {
		if (currentUser) {
			navigate(`${paths.orders}/${slug}`);
		} else {
			dispatch(setLoginModalOpen(true));
		}
	};

	const currentLanguage: string = i18n.language;

	const productName = getContentFieldValue({
		entityContent: productData?.content,
		field: CONTENT_FIELDS.NAME,
		language: currentLanguage,
	});

	const productDetailsFull = getContentFieldValue({
		entityContent: productData?.content,
		field: CONTENT_FIELDS.FULL,
		language: currentLanguage,
	});

	return productData ? (
		<>
			<div
				style={{
					background: `url(${productData.imageUrl})`,
					height: '200px',
					width: 'calc(100% - 40px)',
					marginTop: '65px',
					margin: '65px auto 0 auto',
					borderRadius: '10px',
				}}
			/>
			<div className="ProductDetails">
				<div className="ProductDetails__wrapper">
					<Typography variant="h3" component="h3" sx={{ fontWeight: 600 }}>
						{productName}
					</Typography>
					<div style={{ margin: '20px 0' }}>
						<CtaButton variant="contained" disableElevation onClick={handleOrder}>
							{t('order')}
						</CtaButton>
					</div>
					{productDetailsFull && <ContentRenderer html={productDetailsFull} />}
				</div>
			</div>
		</>
	) : (
		<PageLoader />
	);
};

export default ProductDetails;
